<template>
    <section id="hero" class="hero" v-if="heroData.image">        
        <img v-if="heroData.image" 
            :src="src_url + '/' + heroData.image.path + heroData.image.file_name" 
            class="img-fluid"
            :srcset="heroData.image.srcset"
            sizes="100vw" 
        />
        <div class="hero__text">
            <div>{{ heroData.short_description }}</div>
            <div>{{ heroData.description}}</div>
            <router-link :to="{name: 'Products_'+ currentLangName()}" class="btn btn--primary"><span>{{ lang('megnezem_a_termeket')}}</span></router-link>
        </div>
    </section>
</template>

<script>
import axios from 'axios'

export default {
    data(){
        return {            
            heroData: {},
            src_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME
        }
    },   
    methods:{
        getHeroData(){     
            let _this = this          

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/information/279?&where[0][0]=where&where[0][1]=status&where[0][2]=1&select[0]=image&select[1]=short_description&select[2]=description',{            
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {                
                if (response.data.status == true ){
                    _this.heroData = response.data.information[0]                 
                } else {
                    _this.heroData = {}              
                }                                                          
            })
            .catch((err) => {
                console.log(err)
            });
        }
    },
    created(){
        this.getHeroData()
    }
}
</script>